module.exports = __webpack_public_path__ + "img/NVC.26948896.svg";